import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Home from './Home';
import Terms from './pages/Terms';
import CookiePolicy from './pages/CookiePolicy';
import TopicSelector from './components/TopicSelector';
import PlotGenerator from './components/PlotGenerator';
import Chatbox from './components/chatbox';
import Calculator from './components/Calculator';
import QuestionSearch from './components/QuestionSearch';
import Upload from './pages/Upload';
import Navigator from './components/Navigator';
import AuthProtectedComponent from './components/AuthProtectedComponent';
import { AuthProvider } from './components/AuthContext';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import LatexEditor from './pages/LatexEditor';
import MathPlatformIntro from './components/MathPlatformIntro';
import Logout from './components/Logout';
import Register from './components/Register';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import ImageTextConverter from './components/MiniApp/ImageTextConvertor';
import GoogleDriveExplorer from './components/MiniApp/GoogleDriveExplorer';
import NetworkGraph from './components/MiniApp/NetworkGraph';
import FormulaSearch from './components/MiniApp/FormulaSearch';
import Profile from './components/Profile';
import ExamGrader from './components/ExamGrader';
import QuestionDetail from './components/QuestionDetail';
import PdfEditor from './components/MiniApp/pdfEditor';
import S3FileExplorer from './components/MiniApp/s3-file-explorer';
import AddQuestions from './pages/AddQuestions';
import PendingQuestionsList from './pages/PendingQuestionsList';
import PendingQuestionDetail from './pages/PendingQuestionDetail';
import QuizSetupWizard from "./components/QuizSetupWizard";
import UserMetricsDashboard from './pages/UserStats';
function App() {
  return (

    <Router>
      <AuthProvider>
        <Navigator />
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/image-text-convertor" element={<ImageTextConverter />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/" element={<MathPlatformIntro />} />
          <Route element={<PrivateRoute />}>
            <Route
              path="/home"
              element={
                <AuthProtectedComponent>
                  <Home />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/topic-selector"
              element={
                <AuthProtectedComponent>
                  <TopicSelector />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/plot-generator"
              element={
                <AuthProtectedComponent>
                  <PlotGenerator />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/chatbox"
              element={
                <AuthProtectedComponent>
                  <Chatbox />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/calculator"
              element={
                <AuthProtectedComponent>
                  <Calculator />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/question-search"
              element={
                <AuthProtectedComponent>
                  <QuestionSearch />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/quiz-generator"
              element={
                <AuthProtectedComponent>
                  <QuizSetupWizard />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/exam-question/:id"
              element={
                <AuthProtectedComponent>
                  <QuestionDetail />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/cookie-policy"
              element={
                <AuthProtectedComponent>
                  <CookiePolicy />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/upload"
              element={
                <AuthProtectedComponent>
                  <AddQuestions />
                </AuthProtectedComponent>
              }
            />
            <Route path="questions/edit/:id" element={<AddQuestions />} />
            <Route
              path="/pending-questions"
              element={
                <AuthProtectedComponent>
                  <PendingQuestionsList />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/pending-questions/:id"
              element={
                <AuthProtectedComponent>
                  <PendingQuestionDetail />
                </AuthProtectedComponent>
              }
            />
            <Route path="/questions/edit" element={<AddQuestions />} />
            <Route
              path="/profile"
              element={
                <AuthProtectedComponent>
                  <Profile />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/latex-editor"
              element={
                <AuthProtectedComponent>
                  <LatexEditor />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/image-text-convertor"
              element={
                <AuthProtectedComponent>
                  <ImageTextConverter />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/google-drive"
              element={
                <AuthProtectedComponent>
                  <GoogleDriveExplorer />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/past-papers"
              element={
                <AuthProtectedComponent>
                  <S3FileExplorer />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/knowledge-network"
              element={
                <AuthProtectedComponent>
                  <NetworkGraph />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/formula-search"
              element={
                <AuthProtectedComponent>
                  <FormulaSearch />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/exam-grader"
              element={
                <AuthProtectedComponent>
                  <ExamGrader />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/pdf-editor"
              element={
                <AuthProtectedComponent>
                  <PdfEditor />
                </AuthProtectedComponent>
              }
            />
            <Route
              path="/user-stat"
              element={
                <AuthProtectedComponent>
                  <UserMetricsDashboard />
                </AuthProtectedComponent>
              }
            />
          </Route>

        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
